"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CANCEL_ERROR = exports.ASYNC_SUCCESS_SUFFIX = exports.ASYNC_FAILURE_SUFFIX = exports.ASYNC_CANCEL_SUFFIX = void 0;
exports.combineModels = combineModels;
exports.createAction = createAction;
exports.createReducer = createReducer;
exports.generateActionCreator = generateActionCreator;
exports.generateAsyncActionCreator = generateAsyncActionCreator;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _lodash = _interopRequireDefault(require("lodash"));

var _env = require("./env");

var _invariant = _interopRequireDefault(require("invariant"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty2(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty2(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ASYNC_SUCCESS_SUFFIX = '/SUCCESS';
exports.ASYNC_SUCCESS_SUFFIX = ASYNC_SUCCESS_SUFFIX;
var ASYNC_FAILURE_SUFFIX = '/FAILURE';
exports.ASYNC_FAILURE_SUFFIX = ASYNC_FAILURE_SUFFIX;
var ASYNC_CANCEL_SUFFIX = '/CANCEL';
exports.ASYNC_CANCEL_SUFFIX = ASYNC_CANCEL_SUFFIX;
var CANCEL_ERROR = 'CANCEL_ERROR';
/**
 * Creates a single reducer from given reducer functions and initial state
 * @param  {Object} initialState
 * @param  {Object} handlers
 * @return {function}
 */

exports.CANCEL_ERROR = CANCEL_ERROR;

function createReducer(initialState, handlers) {
  return function reducer(state, action) {
    if (!state) return initialState;
    var handler = handlers[action.type];

    if (handler && _lodash.default.isFunction(handler)) {
      return handler(state, action);
    }

    return state;
  };
}

function createAction(type, payload, error, meta) {
  var action = {
    type: type,
    payload: payload,
    error: error,
    meta: meta
  }; // Remove undefined action nodes

  for (var key in action) {
    if (action[key] === undefined) {
      delete action[key];
    }
  }

  return action;
}

function generateActionCreator(actionName) {
  return function (payload, error, meta) {
    return createAction(actionName, payload, error, meta);
  };
}

function generateAsyncActionCreator(actionName, request, actionCreators) {
  return function (payload) {
    return function (dispatch, getState) {
      dispatch(createAction(actionName, payload)); // We pass down the models actions as dispatchers to the request function

      var actionDispatchers = {};

      var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];

        actionDispatchers[key] = function (payload) {
          return dispatch(actionCreator(payload));
        };
      };

      for (var key in actionCreators) {
        _loop(key);
      }

      var requestPromise = request(payload, actionDispatchers, dispatch, getState); // invariant(
      //   requestPromise instanceof Promise,
      //   'The async action request MUST return a promise!'
      // );

      return requestPromise.then(function (response) {
        var _context;

        // Note that for flexibility, we are passing along
        //  both the response AND the original payload.
        //  This is useful if the API you are interfacing with
        //  doesn't provide verbose responses.
        dispatch(createAction((0, _concat.default)(_context = "".concat(actionName)).call(_context, ASYNC_SUCCESS_SUFFIX), response, undefined, payload ? {
          originalPayload: payload
        } : undefined));
        return response;
      }).catch(function (e) {
        var _context2;

        // Handle promise cancellation differently from normal errors
        var suffix = e.problem === CANCEL_ERROR ? ASYNC_CANCEL_SUFFIX : ASYNC_FAILURE_SUFFIX;
        var error = {
          message: e.message,
          code: e.code,
          problem: e.problem,
          sourceAction: actionName,
          originalError: e
        };
        dispatch(createAction((0, _concat.default)(_context2 = "".concat(actionName)).call(_context2, suffix), {
          error: error
        }, true, payload ? {
          originalPayload: payload
        } : undefined)); // Add action name to error object, so the error origin can be handled
        // by the application if needed

        e.sourceAction = actionName; // Throw the error received to make sure the component or whoever
        //  dispatched the action can deal with it as well :)

        throw e;
      });
    };
  };
}
/**
 * Combines models to be passed into redux's `combineReducers` function
 * @param  {string} namespace
 * @param  {Object} models
 * @return {Function} Combined reducers
 */


function combineModels(namespace, models) {
  // NOTE: the following is just for backwards compatibility and should be removed with the next
  //  major release!
  if ((0, _isArray.default)(namespace)) {
    if (_env.__DEV__) {
      console.warn("This syntax for 'combineModels' is deprecated. Please define a namspace when combining your models!\n  combineModels('myNamespace', { modelA, modelB })");
    }

    models = namespace;
    namespace = 'entities';
  }

  var processedModels = {};

  if ((0, _isArray.default)(models)) {
    (0, _forEach.default)(models).call(models, function (model) {
      processedModels[model.modelName] = model.clone({
        namespace: namespace
      });
    });
  } else {
    for (var key in models) {
      // Ensure that all models are actual models
      var model = models[key];
      (0, _invariant.default)(model && typeof model.clone === 'function', "Can not combine models! Please check if '".concat(key, "' is really a model instance from the model generator!"));
      processedModels[key] = model.clone({
        namespace: namespace
      });
    }
  } // When combining models, we basically just create one reducer that manages
  //  calling the individual reducers with their piece of state and merges the
  //  final state to be returned to redux ... this allows you to nest combined
  //  models as well


  return function (state, action) {
    var newState = _objectSpread({}, state || {});

    for (var name in processedModels) {
      newState[name] = processedModels[name](newState[name], action);
    }

    return newState;
  };
}